import styled from 'styled-components'
import { mq } from '../../../styles/mq'

export const IntroContainer = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 100vh;
  height: 100dvh;

  ${mq.medium} {
    display: block;
    align-items: auto;
    width: auto;
    height: auto;
  }
`
export const Title = styled.h1`
  position: relative;
  text-align: left;
  width: 100%;
  max-width: calc(860px + 20%);
  margin: 4rem auto;
  padding-inline: 3rem;
  bottom: 0;

  ${mq.medium} {
    padding-left: 30%;
    max-width: calc(860px + 20%);
  }
  ${mq.large} {
    max-width: calc860px + 20%);
  }
  ${mq.xlarge} {
    padding-left: 20%;
    max-width: calc(1024px + 20%);
    margin: 6rem auto;
  }
`
export const Description = styled.p`
  text-align: left;
  max-width: calc(860px + 20%);
  margin: 4rem auto;
  display: none;
  ${mq.medium} {
    display: block;
    padding-left: 30%;
    max-width: calc860px + 20%);
  }
  ${mq.large} {
    max-width: calc(860px + 20%);
  }
  ${mq.xlarge} {
    padding-left: 20%;
    margin: 6rem auto;
    max-width: calc(1024px + 20%);
  }
`
export const IntroPhoto = styled.div`
  position: absolute;
  left: 54%;
  transform: translateX(-50%);
  bottom: 0;
  height: calc(100% - 60px);
  max-height: calc(100% - 60px);
  aspect-ratio: 2482/2065;
  ${mq.medium} {
    transform: none;
    left: -10%;
    height: 50vw;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(
      rgba(204, 209, 211, 0) 70%,
      rgba(204, 209, 211, 1) 100%
    );
    ${mq.medium} {
      display: none;
    }
  }
  img {
    height: 100%;
  }
`

export const FacesGrid = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1024px;
  mix-blend-mode: darken;
  ${mq.xlarge} {
    max-width: 1412px;
  }
  img {
    width: 20%;
  }
`
